module.exports = __webpack_public_path__ + "b00f4bb785f96f425bfb26371aba36e8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CC.svg
// module id = Xf2d
// module chunks = 0